import React from 'react';

import { getImageData } from '../../../../utils/contentful';

import { Flexbox } from '../../../Flexbox';
import { Layout, Column, BlockContainer } from '../../../Layout';

import CtaWidget from '../../../CtaWidget';
import { AffiliateLogoGrouping } from '../AffiliateLogoGrouping';
import PrivacyPolicyDisclaimer from '../../../FullwidthHero/PrivacyPolicyDisclaimer';
import { Box } from '../../../Box';

import {
  CTAText,
  RelativeBox,
  MobileVersion,
  MobileSubheadingText
} from '../../../FullwidthHero/styles';

import { MobileImage } from '../styles';

import { AffiliateHero2Props } from '../index';

export default function MobileView({
  mobileHeadingText,
  mobileSubheadingText,
  mobileSubheadingSize,
  mobileImage,
  mobileCta,
  affiliateLogo,
  useGreenlightIcon,
  privacyPolicyDisclaimer,
  displayPrivacyPolicyIcon,
  sendConsentEvent
}: AffiliateHero2Props) {
  return (
    <MobileVersion>
      <AffiliateLogoGrouping
        affiliateLogo={affiliateLogo}
        useGreenlightIcon={useGreenlightIcon}
      />
      <Column size={12}>
        <RelativeBox flex={1}>
          {mobileImage && (
            <MobileImage
              {...getImageData(mobileImage)}
              heroImage={true}
              loading="eager"
              data-testid="affiliate-hero-20-mobile-background"
            />
          )}
        </RelativeBox>
      </Column>

      <BlockContainer
        marginTop={{ 0: 'l' }}
        marginBottom="2xl"
        revealOnScroll={false}
      >
        <Layout>
          <Column size={{ 0: 11, tablet: 8 }}>
            <Flexbox
              flexDirection="column"
              margin={[0, 'auto']}
              justifyContent="center"
              alignItems="center"
            >
              <CTAText
                as="h1"
                fontWeight="h2"
                colour="defaultText"
                textAlign="center"
                data-testid="affiliate-hero-20-hero-headline-mobile"
                fontSize="h1_0"
              >
                {(mobileHeadingText || '').replace(/<br>/g, ' ')}
              </CTAText>
              <MobileSubheadingText
                as="h2"
                fontWeight="400"
                lineHeight="ml"
                colour="defaultText"
                textAlign="center"
                marginTop="m"
                data-testid="affiliate-hero-20-hero-subheading-mobile"
                mobileSubheadingSize={mobileSubheadingSize || '1.125'}
              >
                {mobileSubheadingText}
              </MobileSubheadingText>

              {mobileCta && (
                <CtaWidget
                  {...mobileCta?.fields}
                  sysId={mobileCta?.sys?.contentType?.sys?.id}
                  id="affiliate-hero-mobile-cta-widget"
                  module="Hero"
                  sendConsentEvent={sendConsentEvent}
                />
              )}

              {privacyPolicyDisclaimer && (
                <Box marginTop="ml">
                  <PrivacyPolicyDisclaimer
                    privacyPolicyDisclaimer={privacyPolicyDisclaimer}
                    displayPrivacyPolicyIcon={displayPrivacyPolicyIcon}
                  />
                </Box>
              )}
            </Flexbox>
          </Column>
        </Layout>
      </BlockContainer>
    </MobileVersion>
  );
}
